import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import { router } from "./app/router.js";
import { BusinessProvider } from "./lib/business.js";
import { ThemeProvider } from "./lib/theme.js";
import "./styles/brand.css";
import "./styles/global.css";

const queryClient = new QueryClient({
  // Refetch on focus/reconnect: returning to the app must show fresh data even
  // if the SSE stream died silently while away (WhatsApp-like freshness).
  defaultOptions: { queries: { refetchOnWindowFocus: true, refetchOnReconnect: true } },
});

const root = document.getElementById("root");
if (!root) throw new Error("#root not found");

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <BusinessProvider>
          <RouterProvider router={router} />
        </BusinessProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </StrictMode>,
);
